import { render, staticRenderFns } from "./MyFavsEmptyState.vue?vue&type=template&id=5f7b9d60&scoped=true&"
import script from "./MyFavsEmptyState.vue?vue&type=script&lang=js&"
export * from "./MyFavsEmptyState.vue?vue&type=script&lang=js&"
import style0 from "./MyFavsEmptyState.vue?vue&type=style&index=0&id=5f7b9d60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7b9d60",
  null
  
)

export default component.exports